import React from 'react';
import styled from 'styled-components';
import PreOfferAvailableAmounts from '../components/PreOfferAvailableAmounts';

const Wrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 24px;
  overflow: auto;
`;

const MainText = styled.div`
  margin: 16px 0 8px 0;
  font-size: 24px;
  line-height: 32px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.basic2000};
  text-align: center;
`;

const Ofertas = () => {
  return (
    <Wrapper>
      <MainText>¡Buenas noticias!</MainText>
      <PreOfferAvailableAmounts />
    </Wrapper>
  );
};

export default Ofertas;
